import { GroupType, type IGroup, type IPinnedGroupApiItem } from '../types/types'

function resolveGroupType(type: string): GroupType {
  if (type === GroupType.PRIVATE) {
    return GroupType.PRIVATE
  }
  return GroupType.PUBLIC
}

/** Maps GET /groups/pinned list items to the `IGroup` shape consumed by composables and UI. */
export function mapPinnedGroupApiItemToIGroup(item: IPinnedGroupApiItem): IGroup {
  return {
    _id: item.id,
    slug: item.slug,
    name: item.name,
    membersCount: item.membersCount,
    status: 'active',
    locationId: '',
    createdBy: '',
    createdAt: '',
    updatedAt: '',
    settings: {
      groupType: resolveGroupType(item.type),
    },
    branding: {
      logo: item.logo ?? '',
      cover: item.coverImage ?? '',
    },
  }
}
